/**
 * @fileoverview Main customers and commercial references textarea.
 */

import styles from "./Certifications.module.css";

const MainCustomersField = ({ section, company }) => {
  const {
    t,
    getFieldValidationState,
    getErrorMessage,
    handleInputChange,
    handleFieldChange,
  } = section;

  return (
    <div className={styles.inputGroup}>
      <label className={styles.inputLabel}>
        {t(
          "components.certifications.mainCustomersAndCommercialReferencesLabel",
        )}
      </label>
      <textarea
        className={`${styles.mainCustomersAndCommercialReferencesInput} ${
          getFieldValidationState(
            "clientesPrincipalesYReferenciasComerciales",
            company?.clientesPrincipalesYReferenciasComerciales || "",
          ) === "error"
            ? styles.inputError
            : ""
        }`}
        placeholder={t(
          "components.certifications.mainCustomersAndCommercialReferencesPlaceholder",
        )}
        value={company?.clientesPrincipalesYReferenciasComerciales || ""}
        onChange={(e) => {
          const value = e.target.value;
          company.clientesPrincipalesYReferenciasComerciales = value;
          handleInputChange(
            "clientesPrincipalesYReferenciasComerciales",
            value,
          );
          handleFieldChange(
            "clientesPrincipalesYReferenciasComerciales",
            value,
          );
        }}
        maxLength={300}
      />
      {getErrorMessage("clientesPrincipalesYReferenciasComerciales") && (
        <p className={styles.errorMessage}>
          {getErrorMessage("clientesPrincipalesYReferenciasComerciales")}
        </p>
      )}
    </div>
  );
};

export default MainCustomersField;
